module.exports = __webpack_public_path__ + "img/2_133.20994b39.png";